package gr.tech.site.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.styles.Theme
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.dom.*

fun Modifier.relatedSectionStyle(): Modifier =
    this.classNames("container", "py-5")

fun Modifier.relatedSectionHeaderStyle(): Modifier =
    this.classNames("fw-semibold", "mb-2", "fs-5")

fun Modifier.relatedSectionListStyle(): Modifier =
    this.classNames("mb-0", "gap-3")

fun Modifier.relatedSectionListItemStyle(): Modifier =
    this.classNames("mb-1")

val RelatedSectionLinkStyle = CssStyle {
    base {
        Modifier
            .color(Theme.MediumGreen.rgb)
            .textDecorationLine(TextDecorationLine.Underline)
            .transition(Transition.all(200.ms))
    }
    hover {
        Modifier.color(Theme.DarkGreen.rgb)
    }
}

@Composable
fun RelatedSection(links: List<Pair<String, String>>) {
    if (links.isEmpty()) return
    Section(attrs = Modifier.relatedSectionStyle().toAttrs()) {
        P(attrs = Modifier.relatedSectionHeaderStyle().toAttrs()) { Text("Related Content") }
        Ul(attrs = Modifier.relatedSectionListStyle().toAttrs()) {
            links.forEach { (path, text) ->
                Li(attrs = Modifier.relatedSectionListItemStyle().toAttrs()) {
                    Link(
                        path = path,
                        text = text,
                        variant = UncoloredLinkVariant,
                        modifier = RelatedSectionLinkStyle.toModifier(),
                        openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
                        openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                    )
                }
            }
        }
    }
}
